import { useEffect as i } from "react";
function s(t, e, o) {
  i(() => {
    if (!t) return;
    function r(n) {
      var d;
      (d = o.current) != null && d.contains(n.target) || e(!1);
    }
    function u(n) {
      n.key === "Escape" && e(!1);
    }
    return document.addEventListener("mousedown", r), document.addEventListener("keydown", u), () => {
      document.removeEventListener("mousedown", r), document.removeEventListener("keydown", u);
    };
  }, [t, e, o]);
}
export {
  s as useCloseOnOutsideClick
};
